import { cn } from '@src/components/ui';


/** Collapsible sidebar shell — 248px open / 68px collapsed (DESIGN.md `sidebar`).
 * On mobile (no persistent rail in the M frames) it is an off-canvas overlay:
 * hidden until the page top-bar menu button opens it, with a tap-to-close backdrop. */
function SidebarDrawer(props) {
  const { open = true, onClose, className, children } = props;

  return (
    <>
      {open
        ? (
          <div
            aria-hidden="true"
            className="fixed inset-0 z-20 bg-scrim lg:hidden"
            onClick={onClose}
          />
        )
        : null}

      <aside
        className={cn(
          'h-screen shrink-0 overflow-hidden border-r border-hairline bg-surface-1',
          'transition-[width] duration-200 ease-out',
          open ? 'w-62' : 'w-[68px]',
          'max-lg:fixed max-lg:inset-y-0 max-lg:left-0 max-lg:z-30 max-lg:w-72',
          'max-lg:transition-transform',
          open ? 'max-lg:translate-x-0' : 'max-lg:-translate-x-full',
          className,
        )}
      >
        {children}
      </aside>
    </>
  );
}

SidebarDrawer.displayName = 'SidebarDrawer';
export default SidebarDrawer;
